import {JetView} from "webix-jet"; // Importing JetView from webix-jet framework
import {getColor} from "helpers/chartcolors"; // Importing getColor function from helpers module

/**
 * MoneyView class extends JetView to create a chart view for displaying user financial data.
 */
export default class MoneyView extends JetView {
	/**
	 * Configures the layout of the MoneyView.
	 * @returns {Object} The configuration object for the view.
	 */
	config(){
		const _ = this.app.getService("locale")._; // Localization service for translating text
		return {
			type:"clean", // Clean layout type
			rows:[
				{ 
					template:_("Top Usuarios"), // Header template with localized text
					type:"header", 
					css:"webix_header chart_header" // CSS class for styling the header
				},
				{
					view:"chart", // Chart view configuration
					type:"bar", // Bar chart type
					localId:"chart", // Local ID for referencing the chart
					border:false, // No border around the chart
					radius:0, // No rounded corners
					color:() => getColor(), // Dynamic color assignment using getColor function
					barWidth:24, // Width of the bars in the chart
					padding:{
						top:5, // Padding at the top of the chart
						left:60 // Padding on the left side of the chart
					},
					value:"#money#", // Field to display on the bars
					xAxis:{
						template:"#user#", // Template for x-axis labels
						lines:false, // No lines on the x-axis
						color:"#EDEFF0", // Color of the x-axis
						title:_("Usuario") // Title for the x-axis with localized text
					},
					yAxis:{
						start:0, // Starting value for the y-axis
						step:100, // Step value for the y-axis
						color:"#fff", // Color of the y-axis labels
						lineColor:"#EDEFF0", // Color of the y-axis line
						title:_("Saldo") // Title for the y-axis with localized text
					},
					tooltip:{
						template:"<b>#fname# #lname#</b><br>$#money#" // Tooltip template for displaying user name and money
					}
				}
			]
		};
	}

	/**
	 * Initializes the MoneyView and sets up event listeners.
	 */
	init(){
		const cur_user = this.getParam("user", true); // Retrieve the current user parameter from the URL
		var vthis = this; // Preserve the context of 'this'
		this.on(this.app,"statisticsAgent:MoneyUsers",data => { // Event listener for receiving money user statistics
			vthis.$$("chart").clearAll(); // Clear existing chart data
			vthis.$$("chart").parse(data); // Parse new data into the chart
		});
	}
}

// FILE DOCUMENTED
